import React from 'react'
import DanceCard from './DanceCard'
import styled from 'styled-components'

const DanceList = ({children, dances, isMyDances}) => {
    return (
        <Container>
            {dances?.map((dance) => (
                <DanceCardContainer key={dance._id}>
                    <DanceCard dance={dance} isMyDances={isMyDances} />
                </DanceCardContainer>
            ))}
            {children}
        </Container>
    )
}

export default DanceList

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 1200px) {
        justify-content: center;
    }
`

const DanceCardContainer = styled.div`
    flex-basis: calc(33.33% - 5px);

    @media (min-width: 600px) {
        flex-basis: calc(25% - 5px);
    }

    @media (min-width: 900px) {
        flex-basis: calc(20% - 5px);
    }

    @media (min-width: 1200px) {
        flex-basis: calc(16.66% - 5px);
    }
`
